import {
  get,
} from '.';

// eslint-disable-next-line import/prefer-default-export
export const getSpeciesCategories = () =>
  get('species_categories');
